<div class="provider-logo">
  <img
    class="image image--responsive"
    [src]="imagePath()"
    [alt]="providerName"
    (error)="imageError()"
  />
</div>
